/* eslint-disable indent */
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import { API } from "../../services/api/endpoints/index.js";
import { initTabList } from "../../ui/tabs/index.js";
import { initWhereToBuyMapByFeatures } from "./map.js";

const cititesTabs = document.querySelector(".cities-tabs.where-to-buy");

function initSlider(slider) {
    const id = slider.id;
    return new Swiper(`#${id}`, {
        modules: [Navigation],
        slidesPerView: "auto",
        slideClass: "cities-slider__item",
        navigation: {
            prevEl: `#${id} .cities-slider-arrows-left`,
            nextEl: `#${id} .cities-slider-arrows-right`,
        },
        breakpoints: {
            992: {
                allowTouchMove: true,
            },
        },
    });
}

function initCitiesSliders() {
    const sliders = document.querySelectorAll(".cities-slider");
    if (!sliders.length) return;

    sliders.forEach((slider, index) => {
        slider.id = `cities-slider-${index}`;
        initSlider(slider);
    });
}

function generateCountriesTabs(countries) {
    if (!cititesTabs) return null;

    const countriesTabsBlock = document.createElement("div");
    countriesTabsBlock.classList.add("tabs", "countries-tabs", "where-to-buy");
    countriesTabsBlock.id = "countriesTabs";

    countriesTabsBlock.innerHTML = `
        <div class="tabs__tab-list-wrapper swiper cities-slider">
            <ul class="tabs__tab-list swiper-wrapper cities-slider__wrapper">
                ${countries.map((country, index) => `
                    <li data-country="${country}" data-value=${index}
                        class="cities-slider__item tabs__tab-list-item${index === 0 ? "--selected" : ""}">
                        <button class="tabs__tab-button">${country}</button>
                    </li>
                `).join(" ")}
            </ul>
            <div class="slider-navigation cities-slider__arrows">
                <button class="slider-navigation-prev cities-slider-arrows-left" disabled="">
                    <i class="icon-arrow-left"></i>
                </button>
                <button class="slider-navigation-next cities-slider-arrows-right">
                    <i class="icon-arrow-right"></i>
                </button>
            </div>
        </div>
        <ul class="tabs__tab-panel-list"></ul>
    `;

    return countriesTabsBlock;
}

function generateCountryTabPanel({ country, index, countryData }) {
    const tabPanel = document.createElement("div");
    tabPanel.classList.add(index === 0 ? "tabs__tab-panel-item--show" : "tabs__tab-panel-item");
    tabPanel.dataset.value = index;

    const cities = [];

    // Удаляем дубликаты
    countryData.cities.forEach((cityData) => {
        const cityName = Object.keys(cityData)[0];
        if (!cities.find((c) => Object.keys(c)[0] === cityName)) {
            cities.push(cityData);
        }
    });

    cities.sort((a, b) => {
        const nameA = Object.keys(a)[0];
        const nameB = Object.keys(b)[0];
        return nameA.localeCompare(nameB, "ru");
    });

    if (cities.length > 0) {
        const selectWrapper = document.createElement("div");
        selectWrapper.classList.add("select-where-to-buy");

        const firstCityName = Object.keys(cities[0])[0];
        selectWrapper.innerHTML = `
            <div class="select-where-to-buy__trigger">
                <span>${firstCityName}</span>
                <div class="select-where-to-buy__arrow"></div>
            </div>
            <div class="select-where-to-buy__options"></div>
        `;

        const optionsContainer = selectWrapper.querySelector(".select-where-to-buy__options");
        cities.forEach((city, i) => {
            const cityName = Object.keys(city)[0];
            const coords = city[cityName].coordinates;
            const option = document.createElement("div");
            option.classList.add("select-where-to-buy__option");
            if (i === 0) option.classList.add("select-where-to-buy__option--selected");
            option.dataset.city = cityName;
            option.dataset.center = coords;
            option.dataset.value = i;
            option.textContent = cityName;
            optionsContainer.appendChild(option);
        });

        tabPanel.appendChild(selectWrapper);
    } else {
        tabPanel.dataset.countryOnly = country;
    }

    return tabPanel;
}


function prepareCityPointsData(features) {
    const cityPointsData = {};
    features.forEach((feature) => {
        const content = {
            name: feature.properties.balloonContentHeader,
            content: feature.properties.balloonContentBody,
        };
        const key = feature.city || feature.country;
        if (!cityPointsData[key]) cityPointsData[key] = [];
        cityPointsData[key].push(content);
    });
    return cityPointsData;
}

function renderCityPoints({ container, key, cityPointsData }) {
    container.innerHTML = "";
    if (!cityPointsData[key]) return;

    const cityPoint = document.createElement("div");
    cityPoint.classList.add("cities-points__city");
    cityPoint.dataset.city = key;
    cityPoint.innerHTML = `
        <h3 class="cities-points__heading">${key}</h3>
        <ul class="cities-points__list">
            ${cityPointsData[key].map(item => `
                <li class="cities-points__list-item">
                    <div class="cities-points__list-item-heading">${item.name}</div>
                    ${item.content}
                </li>
            `).join("")}
        </ul>
    `;
    cityPoint.classList.add("cities-points__city--selected");
    container.append(cityPoint);
}

function showLoader(container) {
    container.innerHTML += `
        <div style="width:100%; height:300px; display:flex; align-items:center; justify-content:center;" class="cities-points__loader">
            <i class="loader" style="width: 24px; height: 24px;"></i>
        </div>
    `;
}

function hideLoader(container) {
    const loader = container.querySelector(".cities-points__loader");
    if (loader) loader.remove();
}

async function initWhereToBuy(params) {
    if (!cititesTabs) return;
    const container = document.querySelector(".container");
    if (container) showLoader(container);

    const mapResponse = await API.map.getDataMap();
    const mapData = await mapResponse.json();

    const countries = mapData.countries;
    const countriesList = Object.keys(countries);

    const countriesTabsBlock = generateCountriesTabs(countriesList);
    const tabPanelList = countriesTabsBlock.querySelector(".tabs__tab-panel-list");

    const citiesPoints = document.querySelector(".cities-points");
    const cityPointsData = prepareCityPointsData(mapData.points.features);

    countriesList.forEach((country, index) => {
        const tabPanel = generateCountryTabPanel({
            country,
            index,
            countryData: countries[country],
        });
        tabPanelList.append(tabPanel);
    });

    cititesTabs.replaceWith(countriesTabsBlock);
    initAllCustomSelects({
        showLoader,
        hideLoader,
        renderCityPoints,
        prepareCityPointsData,
        getDataMapByCityOrCountry,
        initWhereToBuyMapByFeatures
    });
    // Обработка выбора города на кастомном селекте
    countriesTabsBlock.addEventListener("click", async (e) => {
        const option = e.target.closest(".select-where-to-buy__option");
        if (!option) return;

        const select = option.closest(".select-where-to-buy");
        const previousSelected = select.querySelector(".select-where-to-buy__option--selected");
        if (previousSelected) previousSelected.classList.remove("select-where-to-buy__option--selected");
        option.classList.add("select-where-to-buy__option--selected");

        const city = option.dataset.city;
        const coords = option.dataset.center.split(",").map(Number);

        select.querySelector(".select-where-to-buy__trigger span").textContent = city;

        if (!city) return;
        let mapContainer = document.getElementById('map');
        mapContainer.innerHTML = "";
        showLoader(citiesPoints);

        const mapData = await getDataMapByCityOrCountry({ city });
        const newCityPointsData = prepareCityPointsData(mapData.points.features);
        const cityCenter = mapData.points.features[0].geometry.coordinates;

        const whereToBuyMap = initWhereToBuyMapByFeatures(mapData.points.features);
        whereToBuyMap.setCenter(cityCenter, 11);

        renderCityPoints({ container: citiesPoints, key: city, cityPointsData: newCityPointsData });
        hideLoader(citiesPoints);
    });

    initTabList(countriesTabsBlock);
    initCitiesSliders();
    countriesTabsBlock.addEventListener("tab-change", async ({ detail }) => {
        const { currentTab } = detail;
        const country = currentTab.dataset.country;
        if (!country) return;

        const tabPanelList = countriesTabsBlock.querySelector(".tabs__tab-panel-list");
        tabPanelList.querySelectorAll(".tabs__tab-panel-item").forEach(p => p.classList.remove("tabs__tab-panel-item--show"));
        const currentPanel = tabPanelList.querySelector(`.tabs__tab-panel-item[data-value="${currentTab.dataset.value}"]`);
        if (currentPanel) {
            currentPanel.classList.add("tabs__tab-panel-item--show");
        }

        const citiesPoints = document.querySelector(".cities-points");
        const mapContainer = document.getElementById('map');
        mapContainer.innerHTML = "";
        showLoader(citiesPoints);
        let select = false;
        if (currentPanel) {
             select = currentPanel.querySelector(".select-where-to-buy");   
        }
        if (select) {
            // страна с городами
            const firstOption = select.querySelector(".select-where-to-buy__option--selected");
            const city = firstOption.dataset.city;

            const mapData = await getDataMapByCityOrCountry({ city });
            const newCityPointsData = prepareCityPointsData(mapData.points.features);
            const cityCenter = mapData.points.features[0].geometry.coordinates;
            const whereToBuyMap = initWhereToBuyMapByFeatures(mapData.points.features);
            whereToBuyMap.setCenter(cityCenter, 11);

            renderCityPoints({ container: citiesPoints, key: city, cityPointsData: newCityPointsData });
        } else {
            // страна без городов
            const countryCoords = countries[country].coordinates;
            const mapData = await getDataMapByCityOrCountry({ country });
            const newCityPointsData = prepareCityPointsData(mapData.points.features);
            const whereToBuyMap = initWhereToBuyMapByFeatures(mapData.points.features);
            whereToBuyMap.setCenter(countryCoords, 7);
            renderCityPoints({ container: citiesPoints, key: country, cityPointsData: newCityPointsData });
        }

        hideLoader(citiesPoints);
    });

    const firstTabPanel = countriesTabsBlock.querySelector(".tabs__tab-panel-item--show");
    const firstSelect = firstTabPanel?.querySelector(".select-where-to-buy");
    if (firstSelect) {
        const firstOption = firstSelect.querySelector(".select-where-to-buy__option--selected");
        if (firstOption) {
            const city = firstOption.dataset.city;

            const mapContainer = document.getElementById('map');
            mapContainer.innerHTML = "";
            showLoader(citiesPoints);

            const firstCityMapData = await getDataMapByCityOrCountry({ city });
            const newCityPointsData = prepareCityPointsData(firstCityMapData.points.features);
            const cityCenter = firstCityMapData.points.features[0].geometry.coordinates;
            const whereToBuyMap = initWhereToBuyMapByFeatures(firstCityMapData.points.features);
            whereToBuyMap.setCenter(cityCenter, 11);

            renderCityPoints({ container: citiesPoints, key: city, cityPointsData: newCityPointsData });
            hideLoader(citiesPoints);
        }
    }

    if (container) hideLoader(container);
}

async function getDataMapByCityOrCountry({ city = null, country = null }) {
    const params = {};
    if (city) params.city = city;
    if (country) params.country = country;
    const formData = new URLSearchParams(params).toString();
    const response = await fetch("/local/ajax/getDataMapByCityOrCountry.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData,
    });
    return await response.json();
}

window.onload = () => {
    initWhereToBuy();
}